/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import MDButton from 'components/MDButton';
import Icon from '@mui/material/Icon';

function ProductUploadExcel({ uploadData }) {
  const fileInput = useRef();

  const handleUploadFile = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      uploadData(reader.result, file);

      if (fileInput.current) {
        fileInput.current.value = '';
      }
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <div>
      <label htmlFor='product-excel-file'>
        <input
          ref={fileInput}
          id='product-excel-file'
          accept='.xlsx'
          style={{ display: 'none' }}
          type='file'
          onChange={handleUploadFile}
        />
        <MDButton variant='outlined' color='success' onClick={handleClick}>
          <Icon color='success'>table_view</Icon>&nbsp;อัพโหลด Excel
        </MDButton>
      </label>
    </div>
  );
}

ProductUploadExcel.propTypes = {
  uploadData: PropTypes.func.isRequired,
};

export default ProductUploadExcel;
